import * as React from 'react';

import {
  BrandschutzWidget,
  ESchiebefensterWidget,
} from './components/BrandschutzESchiebefensterWidget';
import { DoorWidgetWithQuery } from './components/DoorWidget';
import { FensterWidget } from './components/FensterTurenWidget';
import { WidgetBlockRenderers } from '@sorpetaler/ui/src/context/WidgetBlockContext';

// The German site's configurator widgets, keyed by Contentful `widgetType`.
// Injected into RichTextRender via WidgetBlockProvider (see
// wrap-with-metrica-provider). These use graphql/useStaticQuery and therefore
// stay in the site rather than moving to @sorpetaler/ui.
export const deWidgetBlockRenderers: WidgetBlockRenderers = {
  'Fenster widget': <FensterWidget />,
  'Brandschutz widget': <BrandschutzWidget />,
  'Turen widget': <DoorWidgetWithQuery />,
  'E-Schiebefenster widget': <ESchiebefensterWidget />,
};
